<template>
  <div>
    <v-row justify="center">
      <!-- Add/Edit entry dialog box starts here -->
      <v-card>
        <v-card-title>
          <span class="headline">
          {{ entry_data.is_editing ? 'Edit' : 'Add New' }} Attendance Entry
          </span>
        </v-card-title>
        <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <!-- Date picker -->
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="entry_data.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    disabled
                    required
                  > 
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(entry_data.date)"
                        label="Date *"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="entry_data.date"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(entry_data.date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <!-- In time-picker -->
                  <v-dialog
                    ref="inTimeDialog"
                    v-model="inTimeDialog"
                    :return-value.sync="entry_data.inTime"
                    width="300px"
                    required
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="entry_data.inTime ? moment(entry_data.inTime, 'HH:mm').format('LT') : null"
                        label="In time *"
                        prepend-icon="mdi-clock-start"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="inTimeDialog"
                      v-model="entry_data.inTime"
                      format="ampm"
                      width="300px"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="inTimeDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.inTimeDialog.save(entry_data.inTime)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <!-- Out time-picker -->
                  <v-dialog
                    ref="outTimeDialog"
                    v-model="outTimeDialog"
                    :return-value.sync="entry_data.outTime"
                    width="300px"
                    required
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="entry_data.outTime ? moment(entry_data.outTime, 'HH:mm').format('LT') : null"
                        label="Out time *"
                        prepend-icon="mdi-clock-end"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="outTimeDialog"
                      v-model="entry_data.outTime"
                      format="ampm"
                      width="300px"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="outTimeDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.outTimeDialog.save(entry_data.outTime)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                
                <!-- Notes text field -->
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="entry_data.notes"
                    label="Notes (optional)"
                    prepend-icon="mdi-note-outline"
                    ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          <small><b>* indicates required fields</b></small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Close btn for Add entry dialog -->
          <v-btn
            class="blue--text text--darken-2"
            text
            @click="$emit('closeDialog')"
          >
            Close
          </v-btn>
          <!-- Save btn for Add entry dialog -->
          <v-btn
            class="green--text text--darken-1 font-weight-bold"
            text
            @click="saveEntry()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import endpoints from "@api/repository";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";

export default {
  props:{
    entry_data: { // default value if prop not received
      default: () => {
        return {
          id: null,
          date: new Date(),
          inTime: null,
          outTime: null,
          notes: null,
          is_editing: false,
        }
      },
      type: Object
    },
    currentStaff: { // default value if prop not received
      default: () => {
        return {
          id: null,
          name: null
        }
      },
      type: Object 
    }
  },

  data() {
    return {
      moment: moment,
      dialog: false,

      snackbar: {
        visible: false,
        text: "",
      },

      date: null, // date format
      menu: false,
      notes: null,

      // in time data
      inTime: null,
      inTimeDialog: false,

      // out time data
      outTime: null,
      outTimeDialog: false,

      totalWorkingHours: null,
      overtime: null,
      post_body: {  // default post body
        'date': null,
        'staff_id': null,
        'in_time':  null,
        'out_time': null,
        'notes': null,
        'is_editing': false
      }
    }
  },

  computed: {
      ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods: {

    ...mapActions(["setLoading"]),

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if(err.response.status == 406)
      {
        this.snackbar.visible = true;
        this.snackbar.text = err.response.data;
      }
      else if (err.response) {
        console.log(err.response);
        this.snackbar.visible = true;
        this.snackbar.text = "Server error. Please try again later"
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // display selected date in DD/MM/YYYY
    formattedDate(date) {
      if(!date)
        return "";

      return moment(date).format('DD/MM/YYYY');
    },

    // validate entry fields in dialog
    validation() {
      if(this.entry_data.date && this.entry_data.inTime && this.entry_data.outTime) {   // if all fields present
        let in_time = moment(this.entry_data.inTime, 'hh:mm')
        let out_time = moment(this.entry_data.outTime, 'hh:mm');
        if(in_time.isBefore(out_time))    // check if out_time is not before in_time
        {
          return true;
        }
        else
        {
          this.snackbar.text = "Invalid time range";
          this.snackbar.visible = true;
          return false;
        }
      } 
      else
      {
        this.snackbar.text = "All attributes compulsory";   // if all values not entered
        this.snackbar.visible = true;
        return false;
      }
    },

    // save new entry via api after validation
    // handles both add and edit entry
    async saveEntry() {
      if(this.validation()) {   // if all fields valid
        var url = endpoints.addStaffAttendanceEntries;

        this.post_body = {  // post req body
          'date': this.entry_data.date,
          'staff_id': this.currentStaff.id,
          'in_time':  this.entry_data.inTime,
          'out_time': this.entry_data.outTime,
          'notes': this.entry_data.notes,
          'is_editing': this.entry_data.is_editing
        }

        if(this.entry_data.is_editing) {    // edit entry api requires entry-id
          this.post_body.id = this.entry_data.id; 
        }

        // api response
        let response = await api.call(this.apiEssentials, url, api.Methods.POST, this.post_body)

        if(response)   // check null response
        {
          this.$emit('apiResponse', response) // send response back to 
          this.$emit('closeDialog');
        }
      }

      // find the entry using day,month,year -> replace the parent obj

      // console.log("current staff", this.currentStaff);
      // console.log("postbody:",this.post_body);
      
      
      // console.log("entry data",this.entry_data);
    }
  },
}
</script>

<style scoped>
  .v-dialog, .v-dialog--active {
    transition: 0 !important;
  }
</style>